const LOGIN_PATH = "/auth/openpass";
const LANGUAGE_PREFIX_PATTERN = /^\/[a-z]{2}$/;

function normalizeLanguagePrefix(value) {
  return typeof value === "string" && LANGUAGE_PREFIX_PATTERN.test(value)
    ? value
    : "";
}

function buildOpenPassLoginPath(languagePrefix, configuredPath = LOGIN_PATH) {
  const loginPath =
    typeof configuredPath === "string" && /^\/(?!\/)/.test(configuredPath)
      ? configuredPath
      : LOGIN_PATH;
  return `${normalizeLanguagePrefix(languagePrefix)}${loginPath}`;
}

module.exports = {
  buildOpenPassLoginPath,
  normalizeLanguagePrefix,
};
